import { AboutUsHero } from 'sections/aboutUs/aboutUsHero/AboutUsHero';
import { HowWeCooperate } from 'sections/aboutUs/howWeCooperate/HowWeCooperate';
import { ConceptDescription } from 'sections/aboutUs/conceptDescription/ConceptDescription';
import { CalculateEvent } from 'sections/shared/calculateEvent/CalculateEvent';

export const AboutUs = () => {
    return (
        <>
            <AboutUsHero />
            <HowWeCooperate />
            <ConceptDescription />
            <CalculateEvent />
        </>
    );
};
